import React from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import './styles.scss';
import {toastr} from "react-redux-toastr";
import axios from "axios";

export default function StripePaymentForm({ paymentOptions, setProcessing, paymentPath, buttonTitle = 'Pay' }) {
  const stripe = useStripe();
  const elements = useElements();
  const { clientSecret, redirectUrl } = paymentOptions;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setProcessing(true);

    axios.get(paymentPath).then(async (response) => {
      if (response.data.interruption) {
        console.warn(response.data.interruption.status);
        toastr.error('', "Something went wrong!");
        return;
      }

      let confirmFn = null;
      if (/^seti_/.test(clientSecret)) confirmFn = stripe.confirmSetup;
      if (/^pi_/.test(clientSecret)) confirmFn = stripe.confirmPayment;

      if (!confirmFn) return;

      const { protocol, host, pathname, search } = window.location;
      const fullRedirectUrl = `${protocol}//${host}/${redirectUrl}`;

      const result = await confirmFn({
        elements,
        confirmParams: {
          return_url: fullRedirectUrl,
        },
        redirect: 'if_required',
      });


      if (result.error) {
        setProcessing(false);
        toastr.error('', result.error.message)
        console.error(result.error.message);
      }
    }).catch(() => {
      toastr.error('', 'Something went wrong');
      setProcessing(false);
    });
  };

  return (
    <div className='stripe-form'>
      <form onSubmit={handleSubmit}>
        <div className='row'>
          <div className='col-md-12'>
            <div className='input-box'>
              <PaymentElement options={{ layout: 'tabs' }}/>
            </div>
          </div>
        </div>

        <button type="submit"
                className='btn btn-primary btn-lg btn-no-radius pay-button width-100'
                disabled={!stripe}>
          {buttonTitle}
        </button>
      </form>
    </div>
  );
}
